import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=63a46fd6&scoped=true&"
import script from "./GlobalSettings.vue?vue&type=script&lang=js&"
export * from "./GlobalSettings.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=63a46fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a46fd6",
  null
  
)

export default component.exports